<template>
  <h1>Bloqueado</h1>
  <a href="/login">Login</a>
</template>

<script>
export default {

}
</script>

<style>

</style>